const filterAuthorities = (user, prefix) => {
  if (!user || !user.authorities) return []
  const authorities = toRaw(user.authorities)

  return authorities
    .filter((item) => item.authority.startsWith(prefix))
    .map((item) => item.authority)
}

export const isAdmin = (user) => {
  if (!user || !user.authorities) return false
  const authorities = toRaw(user.authorities)
  return authorities.some((item) => item.authority === "RFUK_ADMIN")
}

export const isOfficer = (user) => {
  if (!user || !user.authorities) return false
  const authorities = toRaw(user.authorities)
  return authorities.some((item) => item.authority === "OFFICER")
}

export const isCoordinator = (user) => {
  if (!user || !user.authorities) return false
  const authorities = toRaw(user.authorities)
  return authorities.some((item) => item.authority === "COORDINATOR")
}

export const isObserver = (user) => {
  if (!user || !user.authorities) return false
  const authorities = toRaw(user.authorities)
  return authorities.some((item) => item.authority === "OBSERVER")
}

export const getUserAuthorities = (user) => filterAuthorities(user, "USER")

export const getFormAuthorities = (user) => filterAuthorities(user, "FORM")

export const getAlertAuthorities = (user) => filterAuthorities(user, "ALERT")

export const getCaseAuthorities = (user) => filterAuthorities(user, "CASE")

export const getPlaceAuthorities = (user) => filterAuthorities(user, "PLACE")
